import {remCalc} from '_themeUtils'

const loginDrawer = {
    LoginDrawer: {
        baseStyle: () => ({
            loginBox: {
                w: '100%',
                borderBottom: `${remCalc(1)} solid`,
                borderBottomColor: 'color.border.grey.300',
                paddingBottom: 'spacing.14',
            },
            resetPasswordBox: {
                w: '100%',
                marginBottom: 'spacing.8',
            },
            resetPasswordText: {
                position: 'relative',

            },
            resetPasswordBtn: {
                textTransform: 'lowercase',
                fontWeight: 400,
                px: remCalc(5),
                py: remCalc(7),
                borderTop: `${remCalc(1)} solid transparent`,

                _hover: {
                    borderTopColor: 'color.border.black',
                },
            },
            registrationBox: {
                paddingTop: 'spacing.14',
            },
            registrationTitle: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
                letterSpacing: remCalc(4),
                textTransform: 'uppercase',
            },
            registrationText: {
                textStyle: 'paragraphMd',
                fontWeight: 300,
                letterSpacing: remCalc(0.6),
                paddingTop: 'spacing.4',
                paddingBottom: 'spacing.8',
            },
        }),
    },
}

export default loginDrawer
